import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import {
  Box,
  Typography,
  useTheme,
  Container,
  IconButton,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

// Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import GymCard from "../../../../../Components/GymCard";
export default function GymSlider({ gymsData }) {
  const theme = useTheme();
  const swiperRef = useRef(null);

  const items = gymsData?.map((gym) => (
    <SwiperSlide key={gym._id}>
      <GymCard gym={gym} />
    </SwiperSlide>
  ));

  // Navigation button handlers
  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };
  return (
    <Box sx={{ position: "relative", px: { xs: 0, md: 2 } }}>
      {/* Custom Previous Button */}
      <IconButton
        aria-label="slider prev slide button"
        onClick={handlePrev}
        sx={{
          position: "absolute",
          left: -50,
          top: "45%",
          transform: "translateY(-50%)",
          zIndex: 10,
          bgcolor: "rgba(30, 30, 30, 0.9)",
          backdropFilter: "blur(8px)",
          color: theme.palette.primary.main,
          width: 48,
          height: 48,
          border: `1px solid ${theme.palette.primary.main}4D`,
          transition: "all 0.3s ease",
          "&:hover": {
            bgcolor: theme.palette.primary.main,
            color: "white",
            transform: "translateY(-50%) scale(1.05)",
          },
          display: { xs: "none", md: "inline-flex" },
        }}
      >
        <ChevronLeft sx={{ fontSize: 32 }} />
      </IconButton>

      {/* Custom Next Button */}
      <IconButton
        aria-label="slider next slide button"
        onClick={handleNext}
        sx={{
          position: "absolute",
          right: -50,
          top: "45%",
          transform: "translateY(-50%)",
          zIndex: 10,
          bgcolor: "rgba(30, 30, 30, 0.9)",
          backdropFilter: "blur(8px)",
          color: theme.palette.primary.main,
          width: 48,
          height: 48,
          border: `1px solid ${theme.palette.primary.main}4D`,
          transition: "all 0.3s ease",
          "&:hover": {
            bgcolor: theme.palette.primary.main,
            color: "white",
            transform: "translateY(-50%) scale(1.05)",
          },
          display: { xs: "none", md: "inline-flex" },
        }}
      >
        <ChevronRight sx={{ fontSize: 32 }} />
      </IconButton>

      {/* Swiper Component */}
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        modules={[Navigation, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        loop
        pagination={{ clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          640: { slidesPerView: 1.2, spaceBetween: 16 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 2.5, spaceBetween: 24 },
          1280: { slidesPerView: 3, spaceBetween: 24 },
          // 1600: { slidesPerView: 3.5, spaceBetween: 30 },
        }}
        style={{
          padding: "10px 5px 50px 5px",
        }}
      >
        {items}
      </Swiper>

      {/* Custom Swiper Pagination Styles */}
      <Box
        sx={{
          "& .swiper-pagination": {
            bottom: "0px !important",
          },
          "& .swiper-pagination-bullet": {
            background: "rgba(255, 255, 255, 0.4) !important",
            opacity: "1 !important",
            width: "8px !important",
            height: "8px !important",
          },
          "& .swiper-pagination-bullet-active": {
            background: `${theme.palette.primary.main} !important`,
            width: "24px !important",
            borderRadius: "4px !important",
          },
          "& .swiper-slide": {
            height: "auto !important",
          },
        }}
      />
    </Box>
  );
}
